#import "./LocalizedStringFull.graphql"
#import "./TaxedPriceFull.graphql"

fragment OrderProductInfoFull on OrderProductInfo {
  id
  name {
    ...LocalizedStringFull
  }
  price {
    ...TaxedPriceFull
  }
  subcategoryId
  category
  variant {
    id
    label {
      ...LocalizedStringFull
    }
    weightInGrams
  }
  variantType
  attributes {
    id
    type
    value {
      value
      id
      label {
        ...LocalizedStringFull
      }
    }
  }
  legacyId
}
